export default {
      id: "google-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.9328ef59.svg#google",
      toString: function () {
        return this.url;
      }
    }